import { render, staticRenderFns } from "./SatelliteIcon.vue?vue&type=template&id=3ce2a075&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\invoiceasy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce2a075')) {
      api.createRecord('3ce2a075', component.options)
    } else {
      api.reload('3ce2a075', component.options)
    }
    module.hot.accept("./SatelliteIcon.vue?vue&type=template&id=3ce2a075&", function () {
      api.rerender('3ce2a075', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/icon/SatelliteIcon.vue"
export default component.exports